import { createFileRoute } from '@tanstack/react-router'

import { ComponentShowcasePage } from '@/features/component-showcase/pages/component-showcase-page'

export const Route = createFileRoute(
  '/_authenticated/component-showcase',
)({
  component: ComponentShowcasePage,
})